import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../../../../helpers/api';
import { sendRequest } from '../../../../../../../helpers/saga';
import { logger } from '../../../../../../../helpers/logger';
import notifications from '../../../../../../../redux/notifications/actions';

const commentsListApi = new Api('orientations/:id/comments');

function* loadData({ payload }) {
  try {
    const { id, pageSize } = payload;
    const result = yield call(
      sendRequest,
      commentsListApi.load,
      { id, search: { pageSize } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, sortable_columns } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          comments: records,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* sendComment({ payload }) {
  try {
    const { comment, id } = payload;
    const result = yield call(
      sendRequest,
      commentsListApi.createItem,
      { data: { comment: { body: comment } }, id },
      notifications.REQUEST_ERROR,
    );

    if (result?.data) {
      yield put(actions.sendCommentSuccess());

      return yield put(actions.loadData({ id }));
    }
    yield put(actions.sendCommentFailed());
  } catch (error) {
    logger.error(error);
    yield put(actions.sendCommentFailed());
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.SEND_COMMENT, sendComment)]);
}
